<template>
  <div>
    <Form ref="ask" :rules="askInfoRule" :label-width="150" :model="askInfo">
      <div class="title">
        分成设置 <span class="tips">(三者分成比例之和必须为100%）</span>
      </div>
      <FormItem prop="questioner" label="提问者">
        <Input
          class="ask-input"
          placeholder="请输入"
          v-model="askInfo.questioner"
          clearable
        />
        <span>%</span>
      </FormItem>
      <FormItem prop="answerer" label="回答讲师">
        <Input
          class="ask-input"
          placeholder="请输入"
          v-model="askInfo.answerer"
          clearable
        />
        <span>%</span>
      </FormItem>
      <FormItem prop="platform" label="平台方">
        <Input
          class="ask-input"
          placeholder="请输入"
          v-model="platformPrice"
          disabled
          clearable
        />
        <span>%</span>
      </FormItem>

      <div class="title">最小提现金额</div>
      <FormItem prop="min_amounts" label="最小提现金额">
        <Input
          class="ask-input"
          placeholder="请输入"
          v-model="askInfo.min_amounts"
          clearable
        />
        <span>元</span>

        <span> 大于该金额用户才可提现</span>
      </FormItem>
    </Form>
    <div style="text-align: left; margin-left: 100px">
      <Button
        size="large"
        type="primary"
        style="margin: 0 15px"
        @click="submits()"
        >提交</Button
      >
      <Button size="large" @click="reset('smsData')">重置</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AskSetting",
  components: {},
  data() {
    return {
      askInfoRule: {
        questioner: [{ required: true, message: "请输入提问者分成比例" }],
        answerer: [{ required: true, message: "请输入回答讲师分成比例" }],
        min_amounts: [{ required: true, message: "请输入最小提现金额" }],
      },
      askInfo: {
        questioner: "",
        answerer: "",
        platform: "",
        min_amounts: "",
      },
    };
  },
  created() {
    this.getSetting();
  },
  computed: {
    platformPrice() {
      if (!this.askInfo.answerer && !this.askInfo.questioner) {
        return 100;
      }
      this.askInfo.platform =
        100 -
        parseFloat(this.askInfo.answerer) -
        parseFloat(this.askInfo.questioner);
      if (this.askInfo.platform < 0) {
        this.$Message.error("分成比例不能小于0");
        this.askInfo.answerer = this.askInfo.questioner = 10;
        return 80;
      }
      return this.askInfo.platform;
    },
  },
  methods: {
    submits(name) {
      this.$refs.ask.validate((val) => {
        if (val) {
        } else {
          this.$Message.error("输入有误，请检查！");
        }
        this.askInfo.min_amount = this.askInfo.min_amounts * 100;
        this.$http.post("/api/ask/ask/royalty", this.askInfo).then((data) => {
          this.$Message.info("保存成功");
        });
      });
    },
    reset(name) {
      this.getSetting();
    },

    getSetting() {
      this.$http.get("/api/ask/ask/royalty").then((data) => {
        data.min_amounts = data.min_amount / 100;
        this.askInfo = data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ivu-tabs .ivu-tabs-tabpane {
  padding: 20px;
}

.title {
  position: relative;
  margin-bottom: 20px;
  padding: 5px 15px;
}

.title::before {
  display: block;
  position: absolute;
  left: 0;
  top: 7px;
  content: "";
  height: 20px;
  background-color: #2d8cf0;
  width: 4px;
}

.ask-input {
  width: 300px;
  margin-right: 10px;
}

.avatar {
  max-width: 100px;
  margin-right: 20px;
}

.avatar img {
  max-width: 100px;
}

.form-item-sub {
  &:nth-child(2) {
    margin-bottom: 24px;
  }
  /deep/ .ivu-form-item-label {
    width: auto !important;
  }
}
</style>
